import * as React from 'react'
import { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Link } from 'widgets-for-react'
import { ImageSize } from '../../../../cms/blocks/types.gen'
import { parseImageUrl } from '../../../../drupal/rendering/image_utils.mod'
import { ParsedMediaImage } from '../../../../drupal/types_and_parser/types'
import { CMSState } from '../../../drupalPage/state'

export type QuotesBlockProps = {
  title?: string
  quotes: QuoteSlideProps[]
  cmsState?: CMSState
  isStyleguide?: boolean
}

export type QuoteSlideProps = {
  field_image?: ParsedMediaImage
  image?: number
  image_alt?: string
  image_size?: ImageSize

  imageStyleguide?: {
    src: string
    srcSet: string
    alt: string
  }

  person?: string
  person_function?: string | null
  quote?: string

  btn?: {
    url: string
    label: string
  }
}

export const QuotesBlock = (props: QuotesBlockProps) => {
  const { title, quotes, cmsState, isStyleguide } = props

  return (
    <section className="quotes">
      <div className="quotes__inner">
        <div className="container container--m grid--gutter">
          {title && <h2 className="quotes__title">{title}</h2>}
          <Swiper
            className="quotes__carousel carousel"
            modules={[Navigation, Pagination]}
            spaceBetween={40}
            slidesPerView={1}
            navigation
            pagination={quotes.length > 1 ? { clickable: true } : false}
          >
            {quotes.map((slide, index) => {
              const {
                field_image,
                image,
                image_alt,
                image_size,
                person,
                person_function,
                quote,
                btn,
                imageStyleguide
              } = slide

              // The tag is optional in the CMS, so only join the parts that hold text.
              const label = [person, person_function]
                .map((part) => part?.trim())
                .filter((part) => part)
                .join(', ')

              return (
                <SwiperSlide className="carousel__slide" key={`carousel__slide-${index}`}>
                  <div className="carousel__inner">
                    {/* The visual is always rendered: without an image the swirl falls back to the brand blue. */}
                    <div className="carousel__column carousel__column--visual">
                      <div className="carousel__visual">
                        {isStyleguide ? (
                          <img
                            className="carousel__image lazyload"
                            src="/images/empty.png"
                            data-src={imageStyleguide.src}
                            data-srcSet={imageStyleguide.srcSet}
                            alt={imageStyleguide.alt}
                            sizes="auto"
                            width="520"
                            height="600"
                          />
                        ) : (
                          image && (
                            <img
                              className="carousel__image lazyload"
                              src="/images/empty.png"
                              data-src={`${field_image?.field_media_image?.image?.style_urls['450x450']}`}
                              data-srcset={`${parseImageUrl(
                                field_image?.field_media_image?.image?.style_urls['450x450']
                              )} 450x450, ${parseImageUrl(
                                field_image?.field_media_image?.image?.style_urls['600x600']
                              )} 600x600, ${parseImageUrl(
                                field_image?.field_media_image?.image?.style_urls['1200x1200']
                              )}`}
                              alt={image_alt}
                              sizes="auto"
                              width="450"
                              height="450"
                            />
                          )
                        )}
                      </div>
                    </div>
                    <div className="carousel__column carousel__column--message">
                      <div className="carousel__message">
                        <figure className="carousel__quote">
                          {label && <figcaption className="carousel__label">{label}</figcaption>}
                          {quote && <blockquote className="carousel__title">{quote}</blockquote>}
                        </figure>
                        {btn && (
                          <Link className="carousel__link" to={btn.url}>
                            {btn.label}
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
      </div>
    </section>
  )
}
